import { ClientId } from './enums';
import type { Event } from './types';

const isClientIdValid = (clientId: number) =>
  Object.values(ClientId).includes(clientId);

// TODO @tranct change to schema validation later
export const validateMetricEvent = (event: Event) => {
  const {
    client_id,
    client_name,
    locale,
    event_type,
    browser_name,
    event_value,
    event_duration,
  } = event;

  if (
    typeof client_name !== 'string' ||
    typeof locale !== 'string' ||
    typeof event_type !== 'string' ||
    // The only exception where we can use == instead of ===. This will catch both undefined and null. Please refer to Google style guideline
    // https://google.github.io/styleguide/jsguide.html#features-equality-checks-exceptions
    // eslint-disable-next-line eqeqeq
    (browser_name != null && typeof browser_name !== 'string') ||
    // eslint-disable-next-line eqeqeq
    (event_value != null && typeof event_value !== 'number') ||
    // eslint-disable-next-line eqeqeq
    (event_duration != null && typeof event_duration !== 'number') ||
    // eslint-disable-next-line eqeqeq
    (client_id != null && !isClientIdValid(client_id))
  ) {
    return false;
  }

  return true;
};
